import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DocViewerComponent } from './doc-viewer.component';
import { SharedModule } from '../../../../framework/shared/shared.module';
import { MaterialModule } from '../../../../framework/material/material.module';

@NgModule({
  declarations: [
    DocViewerComponent
  ],
  imports: [
    CommonModule,
    NgxExtendedPdfViewerModule,
    SharedModule,
    MaterialModule
  ],exports:[DocViewerComponent]
})
export class DocViewerModule { }
